import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import sanitizeColor from "./sanitizeColor";

export default function MonogramColorOptions({
  colorKey,
  availableColors,
  config,
  setConfig,
  selectedMessage,
}) {
  const update = (color) => {
    setConfig({ ...config, [colorKey]: color });
  };

  const handleChange = (e) => {
    update(e.target.value);
  };

  if (!config[colorKey]) {
    update(availableColors[0].label);
  }

  return (
    <div className="monogram-config__color">
      <div className="monogram-config__selected-color">
        {selectedMessage.replace("[color]", sanitizeColor(config[colorKey]))}
      </div>
      <div className="monogram-config__color-options">
        {availableColors.map((color) => (
          <label className="monogram-config__color-option-label monogram-config__radio-label">
            <input
              className="monogram-config__color-option-input monogram-config__radio-input"
              type="radio"
              name={`monogram-color-${colorKey}`}
              checked={config[colorKey] === color.label}
              onChange={handleChange}
              value={color.label}
            />
            <div className="monogram-config__swatch-option-wrapper">
              <div
                className="monogram-config__swatch-option-value"
                style={{ backgroundColor: color.color }}
              >
                {color.image ? (
                  <img
                    src={window.getSizedImageUrl(
                      color.image.previewImage.url,
                      "x50",
                    )}
                    className="monogram-config__swatch-image"
                  />
                ) : (
                  <div
                    className={`monogram-config__swatch-image ${color.color === "#FFFFFF" ? "monogram-config__swatch-image--white" : ""} ${color.color ? "" : "monogram-config__swatch-image--placeholder"}`}
                  ></div>
                )}
                <div className="visually-hidden">
                  {sanitizeColor(color.label)}
                </div>
              </div>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}
